<template>
    <div>
        <section class="pt-8 pt-md-11">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                        <h1 class="display-4 text-center">
                            AcreCX at WebSummit 2018
                        </h1>
                        <p class="lead mb-7 text-center text-muted">
                            Come visit our booth at the WebSummit in Lisbon, Portugal.
                        </p>
                        <div class="row align-items-center py-5 border-top border-bottom">
                            <div class="col-6">
                                <time class="font-size-sm text-muted" datetime="2018-11-04">
                                    Published on Nov 04, 2018
                                </time>
                            </div>
                            <div class="col-6 text-right">
                                <span class="h6 text-uppercase text-muted d-none d-md-inline mr-4">
                                  Share:
                                </span>
                                <ul class="d-inline list-unstyled list-inline list-social">
                                    <li class="list-inline-item list-social-item mr-3">
                                        <a class="text-decoration-none" href="#!">
                                            <img alt="..." class="list-social-icon" src="../../../assets/img/icons/social/instagram.svg">
                                        </a>
                                    </li>
                                    <li class="list-inline-item list-social-item mr-3">
                                        <a class="text-decoration-none" href="#!">
                                            <img alt="..." class="list-social-icon" src="../../../assets/img/icons/social/facebook.svg">
                                        </a>
                                    </li>
                                    <li class="list-inline-item list-social-item mr-3">
                                        <a class="text-decoration-none" href="#!">
                                            <img alt="..." class="list-social-icon" src="../../../assets/img/icons/social/twitter.svg">
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="py-6 py-md-8">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                        <p>
                            WebSummit is arguably the best technology conference on the planet. AcreCX and <a href="https://www.truvito.io" target="_blank">TruVito</a> presented at WebSummit 2018 as
                            part of Alpha Startup program.
                        </p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-9 col-xl-8">
                        <div class="form-row mb-3">
                            <!-- Image -->
                            <a class="d-block mb-2 lift lift-lg" data-fancybox="gallery" data-height="1960" data-width="4032" href="/photos/blog/2019/11/20181106_140723.jpg">
                                <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_140723.jpg">
                            </a>
                        </div>
                        <div class="form-row mb-3">
                            <div class="col-6">

                                <!-- Image -->
                                <a class="d-block mt-4 lift lift-lg" data-fancybox="gallery" data-height="4032" data-width="1960" href="/photos/blog/2019/11/20181106_141458_a.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_141458_a.jpg">
                                </a>

                            </div>
                            <div class="col-6">

                                <!-- Image -->
                                <a class="d-block mt-4 lift lift-lg" data-fancybox="gallery" data-height="4032" data-width="1960" href="/photos/blog/2019/11/20181106_175926_a.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_175926_a.jpg">
                                </a>


                            </div>
                        </div>
                        <div class="form-row mb-4">
                            <div class="col-6">

                                <!-- Image -->
                                <a class="d-block mb-2 lift lift-lg" data-fancybox="gallery" data-height="1960" data-width="4032" href="/photos/blog/2019/11/20181106_104333.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_104333.jpg">
                                </a>

                                <!-- Image -->
                                <a class="d-block lift lift-lg" data-fancybox="gallery" data-height="1960" data-width="4032" href="/photos/blog/2019/11/20181106_135237.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_135237.jpg">
                                </a>

                            </div>
                            <div class="col-6">

                                <!-- Image -->
                                <a class="d-block mb-2 lift lift-lg" data-fancybox="gallery" data-height="1960" data-width="4032" href="/photos/blog/2019/11/20181106_175922.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_175922.jpg">
                                </a>

                                <!-- Image -->
                                <a class="d-block mb-2 lift lift-lg" data-fancybox="gallery" data-height="1960" data-width="4032" href="/photos/blog/2019/11/20181106_141518.jpg">
                                    <img alt="..." class="img-fluid rounded" src="/photos/blog/2019/11/20181106_141518.jpg">
                                </a>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "LisbonWebSummit",
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
</style>